import { render, staticRenderFns } from "./notificationRuleGrid.vue?vue&type=template&id=b98190ce&lang=pug&"
import script from "./notificationRuleGrid.vue?vue&type=script&lang=js&"
export * from "./notificationRuleGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports